import { useQuery } from "@apollo/client";

import { GqlPlannerV2VisitGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import useRequireCurrentClient from "../hooks/useRequireCurrentClient";
import { ClientVisitList_GetAllDocument } from "../screens/ClientVisitListScreen/queries.generated";

export function useClientVisitListGetAll(params: GqlPlannerV2VisitGetAllParams) {
    const { client } = useRequireCurrentClient();

    const { data, loading, error } = useQuery(ClientVisitList_GetAllDocument, {
        variables: {
            clientId: client.id,
            params: params,
        },
        fetchPolicy: "cache-and-network",
    });

    const queryInfo = data?.plannerV2VisitGetAll.queryInfo;
    const [filterOptions, total] = useCacheFilterOptions(queryInfo?.filterOptions, queryInfo?.paginationOption.total);

    return {
        loading,
        error,
        total: total,
        sortableColumns: queryInfo?.sortableColumns,
        filterOptions: filterOptions,
        data: data?.plannerV2VisitGetAll.data,
    };
}
